import { Panel } from 'rsuite'
import { FC, ReactNode } from 'react'

import styles from '../../styles/BuyerPortal/ShortcutCard.module.less'

interface ShortcutCardProps {
  title: string
  icon: ReactNode
  description: string
  link: ReactNode
}

const ShortcutCard: FC<ShortcutCardProps> = ({ title, icon, description, link }) => (
  <Panel
    bordered
    className={styles['shortcut-card']}
  >
    <h3 className={styles['shortcut-card__title']}>
      <span className={styles['shortcut-card__icon']}>{icon}</span>
      {title}
    </h3>
    <p className={styles['shortcut-card__description']}>
      {description}
    </p>
    {link}
  </Panel>
)

export default ShortcutCard
